import React from 'react';
import './Terminos.css';

const Terminos = ({ onBack }) => {
    return (
        <div className="public-page">
            <button className="btn-secondary" onClick={onBack}>
                Volver
            </button>
            <header className="public-page-header">
                <h2>Términos y Condiciones</h2>
                <p>Términos de uso y servicio de la plataforma LOTEA</p>
                <p style={{ fontSize: '0.9rem', color: '#666' }}>
                    Última actualización: Enero 2026
                </p>
            </header>

            <section className="public-page-content">
                <h3>1. ACEPTACIÓN DE TÉRMINOS</h3>
                <p>
                    Al acceder y usar LOTEA, aceptas estar vinculado por estos Términos y Condiciones.
                    Si no estás de acuerdo con alguna parte de estos términos, no puedes usar el servicio.
                    LOTEA se reserva el derecho de actualizar estos términos en cualquier momento, siendo
                    responsabilidad del usuario revisar periódicamente cambios.
                </p>

                <h3>2. DESCRIPCIÓN DEL SERVICIO</h3>
                <p>
                    LOTEA es una plataforma web que proporciona herramientas para la administración,
                    visualización interactiva y gestión de proyectos de lotización de terrenos. El servicio
                    incluye funcionalidades para crear, editar y visualizar planos de lotes.
                </p>

                <h3>3. PERÍODO DE PRUEBA GRATUITO</h3>
                <p>
                    <strong>Prueba Gratuita (3 días):</strong> Todos los usuarios nuevos reciben acceso
                    gratuito durante 3 días calendario desde la creación de su cuenta. Durante este período,
                    tendrás acceso completo a todas las funcionalidades de la plataforma.
                </p>
                <p>
                    <strong>Finalización de Prueba:</strong> Después de 3 días, tu acceso será limitado
                    hasta que selecciones e actives un plan de pago. Podrás elegir entre planes mensuales o anuales.
                </p>
                <p>
                    <strong>Conversión a Pago:</strong> Si no seleccionas un plan al finalizar tu período de prueba,
                    tu cuenta continuará con acceso limitado. Para continuar usando todas las funciones, deberás
                    actualizar tu perfil y elegir un plan de suscripción.
                </p>

                <h3>4. SUSCRIPCIONES Y PAGOS</h3>
                <p>
                    <strong>Planes Disponibles:</strong> LOTEA ofrece 3 planes de suscripción:
                </p>
                <ul>
                    <li><strong>Starter:</strong> $29/mes o $290/año (Ahorra $58 con plan anual)</li>
                    <li><strong>Professional:</strong> $79/mes o $790/año (Ahorra $158 con plan anual)</li>
                    <li><strong>Enterprise:</strong> Contactar para presupuesto personalizado</li>
                </ul>
                <p>
                    Los planes mensuales se renuevan cada mes calendario, mientras que los planes anuales se renuevan cada 12 meses.
                </p>
                <p>
                    <strong>Renovación Automática:</strong> Tu suscripción se renovará automáticamente al final de
                    cada período (mensual o anual) a menos que canceles con anticipación.
                </p>
                <p>
                    <strong>Cambios de Plan:</strong> Puedes cambiar tu plan de suscripción en cualquier momento
                    desde tu perfil. Los cambios tomarán efecto inmediatamente o en el siguiente ciclo de facturación,
                    según sea aplicable.
                </p>
                <p>
                    <strong>Reembolsos:</strong> No se otorgan reembolsos por períodos parciales. Las cancelaciones
                    entrarán en vigor al final del período de facturación actual.
                </p>

                <h3>5. RESPONSABILIDADES DEL USUARIO</h3>
                <p>El usuario se compromete a:</p>
                <ul>
                    <li>Proporcionar información precisa y completa en el registro de cuenta</li>
                    <li>Mantener la confidencialidad de sus credenciales de acceso</li>
                    <li>Usar la plataforma de manera legal y ética</li>
                    <li>No intentar acceder a funciones no autorizadas o datos de otros usuarios</li>
                    <li>No usar la plataforma para distribución de malware, contenido ilegal o haciéndose pasar por otros</li>
                    <li>Respetar los derechos de propiedad intelectual de LOTEA y otros usuarios</li>
                    <li>Ser responsable de todo el contenido que carga a la plataforma</li>
                </ul>

                <h3>6. PROPIEDAD INTELECTUAL</h3>
                <p>
                    LOTEA, incluyendo su software, interfaz, diseño, características y contenido, es propiedad
                    exclusiva de sus desarrolladores. Todos los derechos de autor, marcas registradas y otros
                    derechos de propiedad intelectual están protegidos.
                </p>
                <p>
                    Se otorga una licencia limitada para usar LOTEA de acuerdo con estos términos. Está prohibido
                    copiar, modificar, distribuir, reproducir o usar la plataforma con fines comerciales sin
                    autorización explícita.
                </p>
                <p>
                    Los datos y contenidos que cargues (planos, proyectos, información de lotes) permanecen siendo
                    tu propiedad. Al cargar contenido, otorgas a LOTEA una licencia para almacenar, procesar y
                    mostrar dicho contenido dentro de tu cuenta.
                </p>

                <h3>7. LIMITACIÓN DE RESPONSABILIDAD</h3>
                <p>
                    LOTEA se proporciona <strong>tal como está</strong> sin garantías de ningún tipo, explícitas o implícitas.
                    LOTEA no garantiza que el servicio sea interrumpido, seguro o libre de errores.
                </p>
                <p>
                    <strong>Limitación de Daños:</strong> En ningún caso LOTEA será responsable por daños directos,
                    indirectos, incidentales, especiales o consecuentes, incluyendo pero no limitado a pérdida de datos,
                    lucro cesante o daños al equipo, incluso si se ha informado de la posibilidad de tales daños.
                </p>
                <p>
                    <strong>Respaldo de Datos:</strong> Es tu responsabilidad mantener copias de seguridad de tus
                    datos. LOTEA no es responsable por la pérdida, corrupción o inaccesibilidad de tu información.
                </p>

                <h3>8. SUSPENSIÓN Y TERMINACIÓN</h3>
                <p>
                    LOTEA puede suspender o terminar tu acceso a la plataforma si:
                </p>
                <ul>
                    <li>Violas estos Términos y Condiciones</li>
                    <li>Realizas actividades ilegales o no autorizadas</li>
                    <li>No realizas pago de suscripción después del período de gracia</li>
                    <li>Tu cuenta es usada de forma que afecta la seguridad o rendimiento del servicio</li>
                    <li>Acosoas, amenazas o abusas de otros usuarios o del personal de LOTEA</li>
                </ul>

                <h3>9. MODIFICACIONES DEL SERVICIO</h3>
                <p>
                    LOTEA se reserva el derecho de modificar, actualizar o discontinuar cualquier aspecto del servicio
                    en cualquier momento. Nos comprometemos a notificar cambios significativos a nuestros usuarios con
                    anticipación cuando sea posible.
                </p>

                <h3>10. ENLACES Y CONTENIDO EXTERNO</h3>
                <p>
                    LOTEA puede contener enlaces a sitios web externos. No somos responsables por el contenido,
                    precisión o prácticas de privacidad de estos sitios. Tu uso de sitios web externos está regido
                    por sus propios términos.
                </p>

                <h3>11. CUMPLIMIENTO LEGAL</h3>
                <p>
                    Aceptas usar LOTEA de conformidad con todas las leyes aplicables. No usarás la plataforma para
                    actividades ilegales, incluyendo pero no limitado a fraude, lavado de dinero o distribución de
                    contenido ilegal.
                </p>

                <h3>12. DISPUTAS Y RESOLUCIÓN</h3>
                <p>
                    Cualquier disputa derivada de estos términos o del uso de LOTEA será resuelta entre las partes.
                    Si no se puede llegar a un acuerdo, se someterá a la jurisdicción de los tribunales competentes.
                </p>

                <h3>13. CONTACTO Y SOPORTE</h3>
                <p>
                    Para preguntas, quejas o solicitudes relacionadas con estos términos,
                    puedes contactarnos a través de la sección de Soporte dentro de la aplicación.
                </p>

                <h3>14. VIGENCIA Y CAMBIOS</h3>
                <p>
                    Estos Términos y Condiciones están vigentes a partir de enero de 2026.
                    Nos reservamos el derecho de actualizarlos en cualquier momento. El uso continuado
                    de LOTEA después de cambios constituye aceptación de los nuevos términos.
                </p>
            </section>
        </div>
    );
};

export default Terminos;